import { CommonModule, DatePipe } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ViewStorePopupComponent } from '../../shared/popups/view-store-popup/view-store-popup.component';
import { BrowserStorageService } from '../../shared/services/common/browser-storage.service';
import { ApiCallsService } from '../../shared/services/network/api-calls.service';
import { UserService } from '../../shared/services/user.service';
import { SafeHtmlPipe } from '../../shared/validators/safe-html.pipe';
import { DATE_TIME_FORMAT } from '../../utils/constants';
import { api } from '../../utils/endpoints';
import { ICONS } from '../../utils/svg-icons';
import { fileDirectories } from '../../utils/view-settings';

@Component({
  selector: 'app-discover-events',
  standalone: true,
  imports: [CommonModule, DatePipe, NgbTooltipModule, SafeHtmlPipe],
  templateUrl: './discover-events.component.html',
  styleUrl: './discover-events.component.scss',
})
export class DiscoverEventsComponent implements OnInit {
  @Input() userLoggedIn = false;

  fileDirectoriesPath = fileDirectories.profile;
  eventList: any[] = [];
  DATE_TIME_FORMAT = DATE_TIME_FORMAT;
  ICONS = ICONS;
  userInfo: any;

  private _router = inject(Router);
  private _storageService = inject(BrowserStorageService);
  private _apiService = inject(ApiCallsService);
  private _ngbModal = inject(NgbModal);
  private _userService = inject(UserService);

  ngOnInit() {
    this.getUpcomingEvents();
    this._userService.user.subscribe((user) => {
      if (user) {
        this.userInfo = user;
      }
    });
  }

  getUpcomingEvents() {
    const params = {
      eventStatus: ['UPCOMING'],
      page: 1,
      limit: 3,
      eventListType: 'publicEvents',
    };

    this._apiService.post(api._eventListing, params).subscribe({
      next: (res: any) => {
        if (res && res.data) {
          this.eventList = res.data.rows;
        }
      },
      error: (err) => console.error('Error fetching discover events:', err),
    });
  }

  viewAllEvents() {
    const path = '/events/eventByOthers';
    const detail = this._storageService.getItem('userDetail');
    if (detail) {
      this._router.navigate([path]);
    } else {
      const modalRef = this._ngbModal.open(ViewStorePopupComponent, {
        scrollable: false,
        backdrop: 'static',
        keyboard: false,
        size: 'filterPopup',
        centered: true,
      });
      modalRef.componentInstance.entity = 'event';
    }
  }

  viewEventDetails(eventDetails: any) {
    const detail = this._storageService.getItem('userDetail');
    if (detail) {
      this._router.navigate(['/events/eventByOthers/' + eventDetails.id]);
    } else {
      const modalRef = this._ngbModal.open(ViewStorePopupComponent, {
        scrollable: false,
        backdrop: 'static',
        keyboard: false,
        size: 'filterPopup',
        centered: true,
      });
      modalRef.componentInstance.entity = 'event';
    }
  }

  getTooltipArray(sportsList: any[]): string {
    if (!sportsList || sportsList.length <= 1) return '';
    return sportsList
      .slice(1)
      .map((item) => item.sport?.name)
      .join(', ');
  }
}
